import orderBy from 'lodash/orderBy'
import { server, toastr } from '@/services/'

const state = {
  items: [],
  partners: [],
  userAccountsProfile: [],
  isFetching: false
}

const getters = {}

const mutations = {
  setItems (state, payload) {
    state.items = payload
  },
  setPartners (state, payload) {
    state.partners = payload
  },
  setUserAccountsProfile(state, payload) {
    state.userAccountsProfile = payload
  },
  setIsFetching (state, payload) {
    state.isFetching = payload
  }
}

const actions = {

  getAllEmployee ({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      server.get('/getUA/Emp').then(
        resp => {
          // dispatch('userService/getAll')
          commit('setItems', orderBy(resp.data.msgContent.data, 'USER_NAME'))
          resolve(true)
        },
        err => {
          reject(err.response)
        }
      )
    })
  },
  getAllPartner ({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      server.get('/getUA/Partner').then(
        resp => {
          commit('setPartners', orderBy(resp.data.msgContent.data, 'USER_NAME'))
          resolve(true)
        },
        err => {
          reject(err.response)
        }
      )
    })
  },
  updateEmployee ({ commit, dispatch }, payload) {
    server.post('/updateUA', payload).then(
      resp => {
        toastr.updateSuccess()
        dispatch('getAllEmployee')
      },
      err => {
        toastr.serverError()
        reject()
      }
    )
  },
  updatePartner ({ commit, dispatch }, payload) {
    server.post('/updateUA', payload).then(
      resp => {
        toastr.updateSuccess()
        dispatch('getAllPartner')
      },
      err => {
        toastr.serverError()
        reject()
      }
    )
  },
  addEmployee ({ commit, dispatch }, payload) {
    server.post('/registerUA_Int/Emp', payload).then(
      resp => {
        toastr.addSuccess()
        dispatch('getAllEmployee')
      },
      err => {
        toastr.serverError()
        reject()
      }
    )
  },
  addPartner ({ commit, dispatch }, payload) {
    server.post('/registerUA_Int/Partner', payload).then(
      resp => {
        toastr.addSuccess()
        dispatch('getAllPartner')
      },
      err => {
        toastr.serverError()
        reject()
      }
    )
  },
  activateAccount({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      server.post('/activateUA', payload).then(
        _ => {
          toastr.info('Account has been activated.')
          dispatch('getAllEmployee')
          resolve()
        },
        _ => {
          toastr.serverError()
          reject()
        }
      )
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
